export default "__VITE_ASSET__DIL2Dn7s__"